import { Controller } from "stimulus";

// Edit form of a vessel exchange rate. Update opens a modal that lists the
// other shipments on the same sailing; applying submits the form with the
// selected ids, and the server updates the whole group in one transaction.
export default class extends Controller {
  static targets = [
    "rateInput",
    "siblingIds",
    "modal",
    "summary",
    "count",
    "list",
    "rowTemplate",
    "apply",
  ];
  static values = { rateId: Number, shipment: String, vessel: String };

  changed(event) {
    event.preventDefault();
    fetch(`/admin/saved_exchanges/${this.rateIdValue}/associated_vessel_exchange_rates`, {
      headers: { Accept: "application/json" },
    })
      .then((response) => response.json())
      .then((siblings) => (siblings.length ? this.openModal(siblings) : this.submit()))
      .catch(() =>
        window.alert("The other shipments on this sailing could not be loaded. Try again.")
      );
  }

  openModal(siblings) {
    this.renderRows(siblings);
    this.summaryTarget.textContent = this.summary();
    this.updateSelection();
    $(this.modalTarget).modal("show");
  }

  renderRows(siblings) {
    this.listTarget.innerHTML = "";
    siblings.forEach((sibling) => {
      const row = this.rowTemplateTarget.content.firstElementChild.cloneNode(true);
      const checkbox = row.querySelector("input");
      checkbox.value = sibling.id;
      checkbox.checked = true;
      row.querySelector("[data-role=title]").textContent = sibling.shipment_title;
      row.querySelector("[data-role=rate]").textContent = sibling.locked
        ? `${sibling.rate} · locked`
        : sibling.rate;
      this.listTarget.appendChild(row);
    });
  }

  summary() {
    const onVessel = this.vesselValue ? ` on ${this.vesselValue}` : "";
    return `New rate ${this.rateInputTarget.value} for ${this.shipmentValue} and the selected shipments${onVessel}.`;
  }

  selectAll(event) {
    event.preventDefault();
    this.setAll(true);
  }

  selectNone(event) {
    event.preventDefault();
    this.setAll(false);
  }

  setAll(checked) {
    this.checkboxes().forEach((checkbox) => (checkbox.checked = checked));
    this.updateSelection();
  }

  updateSelection() {
    const selected = this.selectedIds().length;
    this.countTarget.textContent = `${selected} of ${this.checkboxes().length} selected`;
    this.applyTarget.textContent = selected
      ? `Update and apply to ${selected} shipment${selected === 1 ? "" : "s"}`
      : "Update this shipment only";
  }

  apply() {
    const ids = this.selectedIds();
    this.siblingIdsTarget.value = ids.length ? JSON.stringify(ids) : "";
    $(this.modalTarget).modal("hide");
    this.submit();
  }

  submit() {
    this.element.querySelector("form").requestSubmit();
  }

  checkboxes() {
    return Array.from(this.listTarget.querySelectorAll("input[type=checkbox]"));
  }

  selectedIds() {
    return this.checkboxes()
      .filter((checkbox) => checkbox.checked)
      .map((checkbox) => Number(checkbox.value));
  }
}
